module.exports = __webpack_public_path__ + "img/1534350202.b28549a4.jpg";